<h1 mat-dialog-title>Profile limits</h1>
<div mat-dialog-content>
  {{data.PlayerId}}
</div>